import { createClient } from '@supabase/supabase-js';
import { getStoredSupabaseJwt } from './supabase-token';

// Trim env vars: Vercel `vercel env add` from a piped echo bakes in a trailing
// newline, which gets URL-encoded as %0A on the realtime WS apikey query param
// and breaks all Postgres-changes subscriptions.
export const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL ?? '').trim();
const SUPABASE_ANON_KEY = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim();

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn(
    'Supabase credentials not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'
  );
}

// Pluggable token provider so the auth service can supply a self-healing
// getter (re-mints on expiry) without creating an import cycle
// (services/supabase-auth → lib/supabase). Falls back to the raw stored
// token until the provider registers at app boot.
let accessTokenProvider: (() => Promise<string | null>) | null = null;
export function setSupabaseAccessTokenProvider(fn: () => Promise<string | null>): void {
  accessTokenProvider = fn;
}

export const supabase = createClient(
  SUPABASE_URL || '',
  SUPABASE_ANON_KEY || '',
  {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
    accessToken: async () =>
      accessTokenProvider ? accessTokenProvider() : getStoredSupabaseJwt(),
  }
);
